// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700;800;900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dropdownContainer_A9ljU {
  position: relative;
  display: inline-block;
  width: 100%;
  font-family: "Inter", sans-serif;
  flex: 1 1;
}

.filterSort_ht6lJ {
  font-family: "Inter", sans-serif;
  font-size: 12px;
  font-weight: 400;
  color: var(--black-color);
  height: 35px;
  min-width: 100px;
  background: var(--f4-background);
  padding: 0px 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  gap: 10px;
  text-transform: capitalize;
}

.emailsFilterSort_Xd5Ui {
  font-family: "Inter", sans-serif;
  font-size: 12px;
  font-weight: 400;
  color: var(--black-color);
  height: 20px;
  background: var(--white-background);
  padding: 0 12px;
  min-width: 100px;
  display: flex;
  align-items: center;
  border: 1px solid var(--e5-border);
  justify-content: flex-start;
  cursor: pointer;
  gap: 10px;
  border-left: none;
}

.chevronIcon_Yz8sg {
  margin-top: 1px;
  margin-left: auto;
  color: var(--_292d32-color);
}

.dropdownOptions_bPUvT {
  width: 100%;
  position: absolute;
  top: calc(100% - 2px);
  left: 0;
  margin-top: 4px;
  background: var(--f4-background);
  border-radius: 4px;
  box-shadow: 0px 4px 8px var(--_0000001a-shadow);
  z-index: 1000;
  overflow: hidden;
}

.dropdownOptionsTelematel_nPmWb {
  position: absolute;
  top: calc(100% - 2px);
  left: 0;
  width: 100%;
  margin-top: 4px;
  background: var(--f4-background);
  border-radius: 4px;
  box-shadow: 0px 4px 8px var(--_0000001a-shadow);
  z-index: 1000;
  overflow: hidden;
  padding: 0;
}

.dropdownOption_pt7Vj {
  padding: 8px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  transition: background-color 0.2s;
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: space-between;
  position: relative;
  z-index: 1002;
  color: var(--black-color);

  img {
    width: 15px;
  }
  svg {
    height: 20px;
    width: 20px;
  }
  -webkit-transition: background-color 0.2s;
  -moz-transition: background-color 0.2s;
  -ms-transition: background-color 0.2s;
  -o-transition: background-color 0.2s;
}

.dropdownOption_pt7Vj:hover {
  background-color: var(--db-background);
}

.dropdownOptionHover_wUTTb {
  padding: 8px;
  font-size: 12px;
  font-weight: 500;
  cursor: default;
  -webkit-user-select: none;
          user-select: none;
  transition: background-color 0.2s;
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: space-between;

  img {
    width: 15px;
  }
  svg {
    height: 20px;
    width: 20px;
  }
  -webkit-transition: background-color 0.2s;
  -moz-transition: background-color 0.2s;
  -ms-transition: background-color 0.2s;
  -o-transition: background-color 0.2s;
}

.dropdownOptionHover_wUTTb:hover {
  background-color: var(--f4-background);
  cursor: default;
}

.disabledBtn_m6WzK {
  background-color: transparent;
  cursor: default;
  .dropdownHeader_dpffp{
    cursor: default;
  }
}
.subcategoryTitle_ju78M {
  font-size: 13px;
  padding: 6px;
  color: var(--_2-color);
  font-weight: 700;
  cursor: initial;
}
.dropdownHeader_dpffp {
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
  transition: background-color 0.2s;
  display: flex;
  align-items: center;
  gap: 10px;
  svg {
    height: 20px;
    width: 20px;
  }
}
.acceptButton_kzUJM {
  color: var(--_2-color);
  font-size: 14px;
  font-family: Roboto;
  font-weight: 600;
  line-height: 20.02px;
  word-wrap: break-word;
}




.deleteEmailFormHeader_GX4vz {
  background-color: transparent;
  border: none;
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
  color: var(--_929598-color);
  border-radius: 15px;
  min-width: 20px;
  min-height: 20px;
}

.deleteEmailFormHeader_GX4vz:hover {
  background-color: var(--cf-background);
  color: var(--white-color);
}

.selectWrapper_Sadw4 {
  display: inline-block;
  padding: 2px;
  border-radius: 8px;
  background: linear-gradient(270deg, var(--green), var(--cyan), var(--green-again));
  background-size: 400% 400%;
  animation: neonBorder_uNkZj 5s ease infinite;
}

.selectWrapper_Sadw4 select {
  border: none;
  outline: none;
  padding: 10px;
  border-radius: 6px;
  background-color: var(--black-color);
  color: var(--white-color);
  font-size: 16px;
  appearance: none;
}

@keyframes neonBorder_uNkZj {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/CustomDropdown/CustomDropdown.module.css"],"names":[],"mappings":"AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,gCAAgC;EAChC,SAAO;AACT;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,gCAAgC;EAChC,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,SAAS;EACT,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;EACZ,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,kCAAkC;EAClC,2BAA2B;EAC3B,eAAe;EACf,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,eAAe;EACf,gCAAgC;EAChC,kBAAkB;EAClB,+CAA+C;EAC/C,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,WAAW;EACX,eAAe;EACf,gCAAgC;EAChC,kBAAkB;EAClB,+CAA+C;EAC/C,aAAa;EACb,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,8BAA8B;EAC9B,kBAAkB;EAClB,aAAa;EACb,yBAAyB;;EAEzB;IACE,WAAW;EACb;EACA;IACE,YAAY;IACZ,WAAW;EACb;EACA,yCAAyC;EACzC,sCAAsC;EACtC,qCAAqC;EACrC,oCAAoC;AACtC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,8BAA8B;;EAE9B;IACE,WAAW;EACb;EACA;IACE,YAAY;IACZ,WAAW;EACb;EACA,yCAAyC;EACzC,sCAAsC;EACtC,qCAAqC;EACrC,oCAAoC;AACtC;;AAEA;EACE,sCAAsC;EACtC,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf;IACE,eAAe;EACjB;AACF;AACA;EACE,eAAe;EACf,YAAY;EACZ,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT;IACE,YAAY;IACZ,WAAW;EACb;AACF;AACA;EACE,sBAAsB;EACtB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;AACvB;;;;;AAKA;EACE,6BAA6B;EAC7B,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,kBAAkB;EAClB,kFAAkF;EAClF,0BAA0B;EAC1B,4CAAsC;AACxC;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,kBAAkB;EAClB,oCAAoC;EACpC,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,2BAA2B;EAC7B;AACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700;800;900&display=swap\");\n\n.dropdownContainer {\n  position: relative;\n  display: inline-block;\n  width: 100%;\n  font-family: \"Inter\", sans-serif;\n  flex: 1;\n}\n\n.filterSort {\n  font-family: \"Inter\", sans-serif;\n  font-size: 12px;\n  font-weight: 400;\n  color: var(--black-color);\n  height: 35px;\n  min-width: 100px;\n  background: var(--f4-background);\n  padding: 0px 12px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  cursor: pointer;\n  gap: 10px;\n  text-transform: capitalize;\n}\n\n.emailsFilterSort {\n  font-family: \"Inter\", sans-serif;\n  font-size: 12px;\n  font-weight: 400;\n  color: var(--black-color);\n  height: 20px;\n  background: var(--white-background);\n  padding: 0 12px;\n  min-width: 100px;\n  display: flex;\n  align-items: center;\n  border: 1px solid var(--e5-border);\n  justify-content: flex-start;\n  cursor: pointer;\n  gap: 10px;\n  border-left: none;\n}\n\n.chevronIcon {\n  margin-top: 1px;\n  margin-left: auto;\n  color: var(--_292d32-color);\n}\n\n.dropdownOptions {\n  width: 100%;\n  position: absolute;\n  top: calc(100% - 2px);\n  left: 0;\n  margin-top: 4px;\n  background: var(--f4-background);\n  border-radius: 4px;\n  box-shadow: 0px 4px 8px var(--_0000001a-shadow);\n  z-index: 1000;\n  overflow: hidden;\n}\n\n.dropdownOptionsTelematel {\n  position: absolute;\n  top: calc(100% - 2px);\n  left: 0;\n  width: 100%;\n  margin-top: 4px;\n  background: var(--f4-background);\n  border-radius: 4px;\n  box-shadow: 0px 4px 8px var(--_0000001a-shadow);\n  z-index: 1000;\n  overflow: hidden;\n  padding: 0;\n}\n\n.dropdownOption {\n  padding: 8px;\n  font-size: 12px;\n  font-weight: 500;\n  cursor: pointer;\n  user-select: none;\n  transition: background-color 0.2s;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  justify-content: space-between;\n  position: relative;\n  z-index: 1002;\n  color: var(--black-color);\n\n  img {\n    width: 15px;\n  }\n  svg {\n    height: 20px;\n    width: 20px;\n  }\n  -webkit-transition: background-color 0.2s;\n  -moz-transition: background-color 0.2s;\n  -ms-transition: background-color 0.2s;\n  -o-transition: background-color 0.2s;\n}\n\n.dropdownOption:hover {\n  background-color: var(--db-background);\n}\n\n.dropdownOptionHover {\n  padding: 8px;\n  font-size: 12px;\n  font-weight: 500;\n  cursor: default;\n  user-select: none;\n  transition: background-color 0.2s;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  justify-content: space-between;\n\n  img {\n    width: 15px;\n  }\n  svg {\n    height: 20px;\n    width: 20px;\n  }\n  -webkit-transition: background-color 0.2s;\n  -moz-transition: background-color 0.2s;\n  -ms-transition: background-color 0.2s;\n  -o-transition: background-color 0.2s;\n}\n\n.dropdownOptionHover:hover {\n  background-color: var(--f4-background);\n  cursor: default;\n}\n\n.disabledBtn {\n  background-color: transparent;\n  cursor: default;\n  .dropdownHeader{\n    cursor: default;\n  }\n}\n.subcategoryTitle {\n  font-size: 13px;\n  padding: 6px;\n  color: var(--_2-color);\n  font-weight: 700;\n  cursor: initial;\n}\n.dropdownHeader {\n  font-size: 12px;\n  font-weight: 500;\n  cursor: pointer;\n  -webkit-user-select: none;\n  user-select: none;\n  transition: background-color 0.2s;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  svg {\n    height: 20px;\n    width: 20px;\n  }\n}\n.acceptButton {\n  color: var(--_2-color);\n  font-size: 14px;\n  font-family: Roboto;\n  font-weight: 600;\n  line-height: 20.02px;\n  word-wrap: break-word;\n}\n\n\n\n\n.deleteEmailFormHeader {\n  background-color: transparent;\n  border: none;\n  cursor: pointer;\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--_929598-color);\n  border-radius: 15px;\n  min-width: 20px;\n  min-height: 20px;\n}\n\n.deleteEmailFormHeader:hover {\n  background-color: var(--cf-background);\n  color: var(--white-color);\n}\n\n.selectWrapper {\n  display: inline-block;\n  padding: 2px;\n  border-radius: 8px;\n  background: linear-gradient(270deg, var(--green), var(--cyan), var(--green-again));\n  background-size: 400% 400%;\n  animation: neonBorder 5s ease infinite;\n}\n\n.selectWrapper select {\n  border: none;\n  outline: none;\n  padding: 10px;\n  border-radius: 6px;\n  background-color: var(--black-color);\n  color: var(--white-color);\n  font-size: 16px;\n  appearance: none;\n}\n\n@keyframes neonBorder {\n  0% {\n    background-position: 0% 50%;\n  }\n  50% {\n    background-position: 100% 50%;\n  }\n  100% {\n    background-position: 0% 50%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dropdownContainer": `dropdownContainer_A9ljU`,
	"filterSort": `filterSort_ht6lJ`,
	"emailsFilterSort": `emailsFilterSort_Xd5Ui`,
	"chevronIcon": `chevronIcon_Yz8sg`,
	"dropdownOptions": `dropdownOptions_bPUvT`,
	"dropdownOptionsTelematel": `dropdownOptionsTelematel_nPmWb`,
	"dropdownOption": `dropdownOption_pt7Vj`,
	"dropdownOptionHover": `dropdownOptionHover_wUTTb`,
	"disabledBtn": `disabledBtn_m6WzK`,
	"dropdownHeader": `dropdownHeader_dpffp`,
	"subcategoryTitle": `subcategoryTitle_ju78M`,
	"acceptButton": `acceptButton_kzUJM`,
	"deleteEmailFormHeader": `deleteEmailFormHeader_GX4vz`,
	"selectWrapper": `selectWrapper_Sadw4`,
	"neonBorder": `neonBorder_uNkZj`
};
export default ___CSS_LOADER_EXPORT___;
